import { MenuItem as HeadlessMenuItem } from '@headlessui/react'
import { ReactNode } from '@tanstack/react-router'
import classNames from 'classnames'

export const ItemHeader = ({ small, children }: { small?: boolean; children: ReactNode }) => {
    return (
        <HeadlessMenuItem disabled>
            <div
                className={classNames('text-secondary font-medium', {
                    'px-2 pb-0.5 pt-1.5 text-xs': small,
                    'px-3 pb-0.5 pt-2': !small,
                })}
            >
                {children}
            </div>
        </HeadlessMenuItem>
    )
}
